import React from 'react';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const ReverseComponentOrderContainer = ({ rendering }) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const preSellingHome =
    rendering &&
    rendering.placeholders &&
    rendering.placeholders.reversingcontenttitledetails &&
    rendering.placeholders.reversingcontenttitledetails[0] &&
    rendering.placeholders.reversingcontenttitledetails[0].fields &&
    rendering.placeholders.reversingcontenttitledetails[0].fields
      .preSellingHome &&
    rendering.placeholders.reversingcontenttitledetails[0].fields.preSellingHome
      .value;
  const messageFlag =
    rendering &&
    rendering.placeholders &&
    rendering.placeholders.reversingcontenttitledetails &&
    rendering.placeholders.reversingcontenttitledetails[0] &&
    rendering.placeholders.reversingcontenttitledetails[0].fields &&
    rendering.placeholders.reversingcontenttitledetails[0].fields.messageFlag &&
    rendering.placeholders.reversingcontenttitledetails[0].fields.messageFlag
      .value;
  const messageFlagLogo =
    rendering &&
    rendering.placeholders &&
    rendering.placeholders.reversingcontenttitledetails &&
    rendering.placeholders.reversingcontenttitledetails[0] &&
    rendering.placeholders.reversingcontenttitledetails[0].fields &&
    rendering.placeholders.reversingcontenttitledetails[0].fields
      .messageFlagLogo &&
    rendering.placeholders.reversingcontenttitledetails[0].fields
      .messageFlagLogo.value;

  return isMobile ? (
    <>
      <Placeholder
        name='reversingcontentgallery'
        rendering={rendering}
        preSellingHome={preSellingHome}
        messageFlag={messageFlag}
        messageFlagLogo={messageFlagLogo}
      />
      <Placeholder name='reversingcontenttitledetails' rendering={rendering} />
    </>
  ) : (
    <>
      <Placeholder name='reversingcontenttitledetails' rendering={rendering} />
      <Placeholder
        name='reversingcontentgallery'
        rendering={rendering}
        preSellingHome={preSellingHome}
        messageFlag={messageFlag}
        messageFlagLogo={messageFlagLogo}
      />
    </>
  );
};
export default ReverseComponentOrderContainer;
